import { GoCheckCircleFill } from 'react-icons/go';
import { MdCancel } from 'react-icons/md';
import { DEFAULT_PASSWORD_RESTRICTION_RULES } from '../../constants/settings';

const PasswordRestrictionRules = ({
  password,
  isTouched,
  error,
}: {
  password: string;
  isTouched: boolean;
  error?: string;
}) => {
  // rendering password restriction rules component here component here
  return (
    <div className='text-sm space-y-1 mt-2'>
      {DEFAULT_PASSWORD_RESTRICTION_RULES.map((rule, index) => (
        <p
          key={index}
          className={`flex items-center gap-1 capitalize ${
            rule.restriction_reg_ex.test(password)
              ? 'text-base-cyan'
              : isTouched && error
              ? 'text-base-red'
              : 'text-gray-300'
          }`}
        >
          {rule.restriction_reg_ex.test(password) ? (
            <GoCheckCircleFill className='size-4' />
          ) : isTouched && error ? (
            <MdCancel className='size-4' />
          ) : (
            <GoCheckCircleFill className='size-4' />
          )}
          {rule.restriction_text}
        </p>
      ))}
    </div>
  );
};

export default PasswordRestrictionRules;
